import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { getPodcastListeners } from "../../../redux/action/dashboard/dashboardAction";

const { RangePicker } = DatePicker;

const LineChart = () => {
  const dispatch = useDispatch();

  const today = dayjs();
  const firstDay = dayjs().subtract(15, "day");

  const [dateRange, setDateRange] = useState([firstDay, today]);
  const [isDateCleared, setIsDateCleared] = useState(false);

  const podcastListeners = useSelector(
    (state) => state.dashboardData?.podcastListeners?.data ?? []
  );

  useEffect(() => {
    const payload =
      isDateCleared || !dateRange
        ? {}
        : {
            from_date: dateRange[0].format("YYYY-MM-DD"),
            to_date: dateRange[1].format("YYYY-MM-DD"),
          };

    dispatch(getPodcastListeners(payload));
  }, [dispatch, dateRange, isDateCleared]);

  const handleDateChange = (dates) => {
    if (!dates || dates.length === 0) {
      setDateRange(null);
      setIsDateCleared(true);
    } else {
      setDateRange(dates);
      setIsDateCleared(false);
    }
  };
  const chartOptions = {
    chart: {
      id: "line-chart",
      toolbar: { show: false },
      zoom: {
        enabled: false,
      },
      animations: {
        enabled: false,
      },
    },
    xaxis: {
      type: "datetime",
      categories: podcastListeners?.map((item) => item?.date),
    },
    stroke: {
      curve: "smooth",
    },
    title: {
      text: "Total Users Over Time",
      align: "left",
    },
  };

  const chartSeries = [
    {
      name: "Total Users",
      data: podcastListeners?.map((item) => item?.listener_count),
    },
  ];

  return (
    <div>
      <div style={{ textAlign: "left" }}>
        <RangePicker
          onChange={handleDateChange}
          format="MM-DD-YYYY"
          defaultValue={dateRange}
          style={{ marginBottom: 20 }}
        />
      </div>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={350}
      />
    </div>
  );
};

export default LineChart;
